import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const dateValidation = (date: string): boolean => dayjs(date).isValid();

export default dateValidation;
